import React, { useState } from "react";
import AvatarImg from "../../../../../images/profile-avatar.png";
import StartImg from "../../../../../images/star.svg";
import ToggleButton from "../../../../commons/ToggleButton";

const ProfessionalSettingsReviews = ({ professional }) => {
  const [showMetric, setShowMetrics] = useState(false);
  const [isToggleEnabled, setIsToggleEnabled] = useState(false);
  const [showMenu, setShowMenu] = useState(null);

  const leadServicesNames =
    professional &&
    professional?.professions
      ?.map((profession) => {
        return profession.services;
      })
      .flat();

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  return (
    <div className="">
      <div className="">
        <div>
          <div className="flex items-center justify-between mb-6">
          <h4 className="text-lg md:text-xl font-bold leading-[180%] text-customGray hidden md:block">
            Reviews
          </h4>
          <div className="flex items-center gap-2.5">
            <h6 className="text-sm font-black leading-[160%] uppercase text-[#485868]">collect reviews:</h6>
            <ToggleButton isEnabled={isToggleEnabled} />
          </div>
          </div>
          <div className="py-6 px-5 border border-solid border-[#EBEFF3] bg-white rounded-md flex md:items-start flex-col md:flex-row gap-4 md:gap-5 mb-[14px]">
            <div className="flex items-center gap-[18px]">
              <img
                src={AvatarImg}
                alt=""
                className="w-[70px] h-[70px] rounded-[50%] bg-[#485868]"
              />
              <div className="flex items-center justify-between md:hidden w-[calc(100%-80px)]">
                <div className="flex items-center gap-0.5 mb-[10px]">
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                </div>
                {/* <GlobalTableDropDown
                  data={professional}
                  showMenu={showMenu === professional?.id}
                  callBack={handleMenuItems}
                  // isLastIndex={index == professionalTable.length - 2}
                  menuItems={professionalReviewsItems}
                /> */}
              </div>
            </div>
            <div className="md:w-[calc(100%-90px)]">
              <div className="hidden md:flex items-center justify-between">
                <div className="flex items-center gap-0.5 mb-[10px]">
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                </div>
                {/* <GlobalTableDropDown
                  data={professional}
                  showMenu={showMenu === professional?.id}
                  callBack={handleMenuItems}
                  // isLastIndex={index == professionalTable.length - 2}
                  menuItems={professionalReviewsItems}
                /> */}
              </div>
              <h6 className="text-base font-bold leading-[160%] text-customGray mb-[10px]">
                I recommend Ryan as an excellent professional
              </h6>
              <p className="text-sm font-normal leading-[170%] text-[#485868] max-w-[600px] mb-[10px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum.
              </p>
              <div className="flex items-center gap-[7px] md:gap-2.5 text-sm font-normal leading-[140%] text-[#485868]">
                <b>Gretchen Philips</b>
                &#x2022;
                <span>XX/XX/XXXX</span>
                &#x2022;
                <span>XX:XX AM</span>
              </div>
            </div>
          </div>
          <div className="py-6 px-5 border border-solid border-[#EBEFF3] bg-white rounded-md flex md:items-start flex-col md:flex-row gap-4 md:gap-5">
            <div className="flex items-center gap-[18px]">
              <img
                src={AvatarImg}
                alt=""
                className="w-[70px] h-[70px] rounded-[50%] bg-[#485868]"
              />
              <div className="flex items-center justify-between md:hidden w-[calc(100%-80px)]">
                <div className="flex items-center gap-0.5 mb-[10px]">
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                </div>
                {/* <GlobalTableDropDown
                  data={professional}
                  showMenu={showMenu === professional.id}
                  callBack={handleMenuItems}
                  // isLastIndex={index == professionalTable.length - 2}
                  menuItems={professionalReviewsItems}
                /> */}
              </div>
            </div>
            <div className="md:w-[calc(100%-90px)]">
              <div className="hidden md:flex items-center justify-between">
                <div className="flex items-center gap-0.5 mb-[10px]">
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                  <img src={StartImg} alt="" />
                </div>
                {/* <GlobalTableDropDown
                  data={professional}
                  showMenu={showMenu === professional.id}
                  callBack={handleMenuItems}
                  // isLastIndex={index == professionalTable.length - 2}
                  menuItems={professionalReviewsItems}
                /> */}
              </div>
              <h6 className="text-base font-bold leading-[160%] text-customGray mb-[10px]">
                I recommend Ryan as an excellent professional
              </h6>
              <p className="text-sm font-normal leading-[170%] text-[#485868] max-w-[600px] mb-[10px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum.
              </p>
              <div className="flex items-center gap-[7px] md:gap-2.5 text-sm font-normal leading-[140%] text-[#485868]">
                <b>Gretchen Philips</b>
                &#x2022;
                <span>XX/XX/XXXX</span>
                &#x2022;
                <span>XX:XX AM</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalSettingsReviews;
